import { normalize } from "../../common";

export const STYLES = {
  fontSizes: {
    mini: normalize(12),
    small: normalize(15),
    medium: normalize(17),
    large: normalize(20),
    xlarge: normalize(24),
    xxlarge: normalize(28),
  },
  colors: {
    black: "#000000",
    fontColor: "#000000",
    lightFontColor: "#b5b5b5",
    white: "#ffffff",
    blueGrey: "#83a4b6",
    darkBlue: "#675ffa",
    powderWhite: "#f6efed",
    purpel: "#8f00ff", //"#a020f0",
    tomato: "tomato",
    lightGrey: "#e0e0e0",
    carribeanGreen: "#05CE91",
  },
  shadow: {
    shadowOffset: {
      width: 2,
      height: 2,
    },
    shadowColor: "#000000",
    elevation: 5,
    shadowOpacity: 0.1,
    backgroundColor: "#fff",
    shadowRadius: 20,
  },
};
